import type { ICampaignCategory } from '../../../components/EsForm/CampaignCategorySelector';
import { generatePrizeStructure } from './awardPresets';

export function generateAwardsFromAnswers(
    category: ICampaignCategory,
    answers: Record<string, string>,
): { prize_structure: NonNullable<ICampaignCategory['prize_structure']> } {
    const layout = answers.award_layout || 'podium_tiers';
    const budget = answers.award_budget || 'medium';

    return {
        prize_structure: generatePrizeStructure(category, layout, budget),
    };
}
